import React from 'react'
import { Link } from 'newComponents'
import MarketoForm from '../../../components/MarketoForm'

const FormCard = ({ marketoFormId }) => (
  <div className="card formCard">
    <MarketoForm formId={marketoFormId} />
    <p className="help">
      By submitting you agree to LaunchDarkly's{' '}
      <Link to="/policies/terms-of-service/" target="_blank" rel="noopener noreferrer">
        Terms{' '}
      </Link>
      and{' '}
      <Link to="/policies/privacy/" target="_blank" rel="noopener noreferrer">
        Privacy Policies
      </Link>
      .
    </p>
  </div>
)

export default FormCard
